import React from 'react'

const Battery = () => (
  <svg
    width="25"
    height="25"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 25 25"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3" y="8" width="16" height="10" rx="2" ry="2" />
    <rect x="19.5" y="10.5" width="2" height="5" rx="0.5" ry="0.5" fill="currentColor" stroke="none" />
    <path d="M11.5 10.5l-2 3h3l-2 3" />
  </svg>
)

export default Battery
